// extracted by mini-css-extract-plugin
export default {"Extend":"Extend_Extend__myl3L","Extend__children":"Extend_Extend__children__A7wqS"};